import { BRAND_COLOR } from '@/constants/colors'

import { SpinnerWrapper } from './styles'

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large'
  color?: string
}

export default function Spinner({ size = 'medium', color = BRAND_COLOR }: SpinnerProps) {
  const backgroundColor = color === '#ffffff' ? 'rgba(255, 255, 255, 0.3)' : '#F0F0F0'

  return (
    <SpinnerWrapper size={size}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' fill='none'>
        <path
          d='M33.7503 19.9998C33.7503 12.4059 27.5942 6.24984 20.0003 6.24984C12.4064 6.24984 6.25032 12.4059 6.25032 19.9998C6.25032 27.5937 12.4064 33.7498 20.0003 33.7498C27.5942 33.7498 33.7503 27.5937 33.7503 19.9998ZM39.5837 19.9998C39.5837 30.8154 30.8159 39.5832 20.0003 39.5832C9.18475 39.5832 0.416992 30.8154 0.416992 19.9998C0.416992 9.18426 9.18475 0.416504 20.0003 0.416504C30.8159 0.416504 39.5837 9.18426 39.5837 19.9998Z'
          fill={backgroundColor}
        />
        <path
          d='M33.7497 19.9998C33.7497 12.4059 27.5936 6.24984 19.9997 6.24984C18.3888 6.24984 17.083 4.944 17.083 3.33317C17.083 1.72234 18.3888 0.416504 19.9997 0.416504C30.8153 0.416504 39.583 9.18426 39.583 19.9998C39.583 25.4774 37.3295 30.4334 33.7074 33.9842C32.5571 35.1119 30.7107 35.0938 29.583 33.9435C28.4559 32.7932 28.4752 30.9466 29.6253 29.8192C32.1741 27.3203 33.7497 23.8466 33.7497 19.9998Z'
          fill={color}
        />
      </svg>
    </SpinnerWrapper>
  )
}
